// T46: nieprzeczytane wiadomości wyskakują po zalogowaniu, jedna po drugiej.
// "Zamknij" aktywne dopiero po 5 sekundach (żeby nikt nie odklikał bez czytania);
// zamknięcie = przeczytane. Bez usuwania — historia zostaje w "Wiadomości".
import React, { useState, useEffect } from 'react';
import { fullName } from './UI';
import api from '../utils/api';

const WAIT = 5;

export default function UnreadPopup({ messages, onDone }) {
  const [index, setIndex] = useState(0);
  const [left, setLeft] = useState(WAIT);
  const [busy, setBusy] = useState(false);
  const msg = messages[index];

  useEffect(() => {
    setLeft(WAIT);
    const t = setInterval(() => setLeft(l => (l > 0 ? l - 1 : 0)), 1000);
    return () => clearInterval(t);
  }, [index, msg?.id]);

  if (!msg) return null;

  const close = async () => {
    if (left > 0 || busy) return;
    setBusy(true);
    try { await api.markRead(msg.id); } catch { /* i tak idziemy dalej */ }
    setBusy(false);
    if (index + 1 < messages.length) setIndex(index + 1);
    else onDone && onDone();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 14, maxWidth: 520, width: '100%', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ fontSize: 10, color: '#64748B', marginBottom: 4 }}>
          ✉️ Wiadomość od <b>{fullName(msg.sender)}</b> · {new Date(msg.createdAt).toLocaleString('pl-PL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
          {messages.length > 1 && <span style={{ float: 'right' }}>{index + 1} z {messages.length}</span>}
        </div>
        <h3 style={{ margin: '0 0 10px', fontSize: 16, fontWeight: 800, color: '#0F172A' }}>{msg.title}</h3>
        <div style={{ fontSize: 14, lineHeight: 1.6, color: '#1E293B', whiteSpace: 'pre-wrap', maxHeight: '50vh', overflowY: 'auto' }}>{msg.content}</div>
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10 }}>
          {left > 0 && <span style={{ fontSize: 11, color: '#94A3B8' }}>przeczytaj — zamknięcie za {left} s</span>}
          <button className="btn btn-primary" onClick={close} disabled={left > 0 || busy} style={{ minWidth: 120 }}>
            {index + 1 < messages.length ? 'Następna' : 'Zamknij'}
          </button>
        </div>
      </div>
    </div>
  );
}
